<template>
    <b-card no-body class="overflow-hidden">
        <b-row no-gutters>
            <b-col md="4">
                <div class="item-photo" :style="style"></div>
            </b-col>
            <b-col md="8">
                <b-card-body
                    title-tag="h6"
                    :title="
                        `${entry.vehicle.plate} - ${entry.vehicle.brand} - (${entry.vehicle_entry_type.name})`
                    "
                >
                    <b-card-text>
                        <table class="table table-sm" v-if="!goingOut">
                            <tbody>
                                <tr>
                                    <td><strong>Fecha Ingreso</strong></td>
                                    <td>{{ entry.created_at | datetime }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Duración</strong></td>
                                    <td>{{ entry.created_at | duration }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Destino</strong></td>
                                    <td>{{ entry.destination.name }}</td>
                                </tr>
                                <tr v-if="!!entry.visited_person">
                                    <td><strong>Persona Visitada</strong></td>
                                    <td>{{ entry.visited_person.name }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Registrado por</strong></td>
                                    <td>{{ entry.user.name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <b-form-textarea
                            v-else
                            v-model="notes"
                            rows="4"
                            autofocus
                        ></b-form-textarea>
                        <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Tipo</th>
                                    <th>Teléfono</th>
                                    <th>Sale</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="personEntry in entry.person_entries"
                                    :key="personEntry.id"
                                >
                                    <td
                                        :class="{
                                            overlined: !!personEntry.completed,
                                        }"
                                    >
                                        {{ personEntry.person.name }}
                                    </td>
                                    <td
                                        :class="{
                                            overlined: !!personEntry.completed,
                                        }"
                                    >
                                        {{ personEntry.visitor_type.name }}
                                    </td>
                                    <td
                                        :class="{
                                            overlined: !!personEntry.completed,
                                        }"
                                    >
                                        {{ personEntry.person.phone }}
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            v-model="passengers"
                                            :value="personEntry.id"
                                            :disabled="!!personEntry.completed"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-text>
                    <b-row>
                        <b-col>
                            <app-form-textarea-input
                                v-if="!goingOut"
                                :readonly="true"
                                label="Notas"
                                id="notas"
                                v-model="previousNotes"
                            ></app-form-textarea-input>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-btn
                            variant="primary"
                            v-if="!goingOut"
                            @click="goingOut = true"
                            >Dar Salida</b-btn
                        >
                        <div v-else>
                            <b-btn variant="secondary" @click="goingOut = false"
                                >Cancelar</b-btn
                            >
                            <b-btn variant="confirm" @click="register"
                                >Confirmar</b-btn
                            >
                        </div>
                    </div>
                </b-card-body>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        goingOut: false,
        notes: '',
        passengers: [],
        previousNotes: ''
    }),
    computed: {
        style() {
            return {
                backgroundImage: `url(${
                    !!this.entry.vehicle.vehicle_photos &&
                    this.entry.vehicle.vehicle_photos.length > 0
                        ? this.entry.vehicle.vehicle_photos[0].photo_url
                        : 'images/generic_vehicle.png'
                })`,
                backgroundPosition: 'center',
                backgroundSize: !!this.entry.vehicle.photo
                    ? 'cover'
                    : 'contain',
                backgroundRepeat: 'no-repeat',
            }
        },
    },
    methods: {
        async register() {
            const { data } = await repo.post(`vehicle-departures`, {
                notes: this.notes,
                userId: this.user.id,
                entryId: this.entry.id,
                passengers: this.passengers,
            })
            const passengersCount = this.passengers.length
            toastr.success('La salida fue registrada satisfactoriamente')
            this.notes = ''
            this.goingOut = false
            this.passengers = []
            this.$emit('departured', { withPassengers: !!passengersCount })
        },
        handleControlAccessNotes() {
            const noteTypes = { entry: 'Ingreso', departure: 'Salida' }
            this.previousNotes = this.entry.vehicle.accessControlComments
                .map(
                    (item) =>
                        `- [${item.created_at}] ${item.notes} (${
                            noteTypes[item.type]
                        })`
                )
                .join('\n')
        },
    },
    created(){
        this.handleControlAccessNotes()
    }
}
</script>
<style scoped>
.item-photo {
    height: 175px;
    display: flex;
    align-items: center;
}
</style>
